module.exports = __webpack_public_path__ + "static/img/expression_wrinkles_disappear-01.67b3679.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/expression_wrinkles_disappear-01.jpg
// module id = 266
// module chunks = 1